import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">WHY REFRAME PROBLEMS?</span>
                                            </div>
                                            <p>We all know how we like to do things – ways that work best
                                                for us. Whether it’s preparing for a presentation, managing
                                                a team or just the way we begin our day. Once we discover
                                                methods that achieve an acceptable result, we decide they’re
                                                successful and stick to them – they become habits of
                                                thinking and doing. This is mostly fine, except on those
                                                occasions when things don’t work out so well. Then, we tend
                                                to think it’s the task or issue in hand that’s the problem
                                                rather than the way we’re dealing with it. And there will
                                                always be things that stump us at work and elsewhere, which
                                                is what the ability to ‘reframe problems’ is all about.</p>
                                            <div className="border_subtitle">Innovative or creative?</div>
                                            <p>Although these words are often used interchangeably, there’s
                                                a subtle difference. People think only artistic people are
                                                ‘creative’ but creativity is just an ability to think
                                                originally and imaginatively about anything, plus the
                                                routine skills necessary for realisation. ‘Innovation’ is a
                                                new process or way of doing things. The What If!<a
                                                    className="superscripttext"
                                                    href="further_info.php?page=1&amp;course=300"><sup>2</sup></a> creative
                                                agency have defined ‘creativity’ as a behaviour and
                                                ‘innovation’ as a process. It’s easy to understand why we
                                                get confused! Think of ‘innovation’ as the process of
                                                putting new, imaginative (‘creative’) ideas into practice.
                                            </p>
                                            <div className="border_subtitle">Pre-cursors to thinking
                                                creatively about problems at work
                                            </div>
                                            <div className="paraspace"><p><strong>How do our brains
                                                work?</strong></p>
                                                <p>Well, even a summary of all the research into this
                                                    subject would make your head spin. However, for the
                                                    purpose of understanding how to reframe problems, here
                                                    are some explanatory insights:</p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>Our brains have evolved over time to make quick
                                                    decisions based on limited information.</p></li>
                                                <li style={{paddingBottom: '9px !important'}}><p>Often our
                                                    ‘gut reactions’ are informed by years of experience and
                                                    other influences. We tend to categorise information to
                                                    help make sense of the world around us. However,
                                                    sometimes our categorisations are over simplified and
                                                    not sufficient for considering new interpretations and
                                                    responses, so we tend to revert to familiar, tried and
                                                    tested methods.</p></li>
                                            </ul>
                                            <p>We weren’t originally ‘programmed’ or inclined to review our
                                                decisions in depth by searching for and making comparisons
                                                with additional or alternative information – and there
                                                wasn’t much point either, when our option was usually to
                                                fight or flee. No time to mess around – go with your
                                                gut!</p>
                                            <div className="paraspace"><p>But things – and we – are very
                                                different now. Habitual methods and interpretations can
                                                close off the variety of options available and stunt
                                                creativity, unless we:</p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>Challenge the tendency to make decisions based on
                                                    tried and tested methods and categorisations.</p></li>
                                                <li style={{paddingBottom: '9px !important'}}><p
                                                    style={{paddingBottom: '8px !important'}}>Actively seek and
                                                    be open to new information or approaches to stimulate
                                                    different ways of thinking about familiar issues.</p>
                                                </li>
                                            </ul>
                                            <div className="border_subtitle">Learnt behaviour?</div>
                                            <p>There has been much debate about whether creativity is an
                                                innate ability or can be learned. It’s true that there are
                                                those who, less constrained by convention, are more adept at
                                                generating ideas, but it’s often only a matter of
                                                approaching issues from a different perspective – and there
                                                are techniques for this which can be learned.</p>
                                            <div className="border_subtitle">How the creative process
                                                works
                                            </div>
                                            <ol className="greenbullet-list paraspace">
                                                <li className="line-height1"><p><span
                                                    className="green brownbold"><b>Insight</b></span>&nbsp; – &nbsp;recognise
                                                    either the challenges or the opportunities (or both) of
                                                    the issue you’re considering.</p></li>
                                                <li className="line-height1"><p><span
                                                    className="green brownbold"><b>Ideas</b></span>&nbsp; – &nbsp;develop
                                                    ideas to realise the opportunities.</p></li>
                                                <li className="line-height1"><p><span
                                                    className="green brownbold"><b>Impact</b></span>&nbsp; – &nbsp;develop
                                                    a strategy for making those ideas happen.</p></li>

                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}